import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { NotificationsState } from './notifications.state';

export const selectNotificationsState = createFeatureSelector<NotificationsState>('notifications');

export const selectNotificationsItems = createSelector(
  selectNotificationsState,
  (s) => s.page.items
);
export const selectNotificationsTotalItems = createSelector(
  selectNotificationsState,
  (s) => s.page.totalItems
);
export const selectNotificationsPage = createSelector(selectNotificationsState, (s) => s.page.page);
export const selectNotificationsPageSize = createSelector(
  selectNotificationsState,
  (s) => s.page.pageSize
);
export const selectNotificationsFilter = createSelector(
  selectNotificationsState,
  (s) => s.page.filter
);
export const selectNotificationsLoading = createSelector(
  selectNotificationsState,
  (s) => s.page.loading
);
export const selectNotificationsError = createSelector(
  selectNotificationsState,
  (s) => s.page.error
);
export const selectNotificationsHasLoaded = createSelector(
  selectNotificationsState,
  (s) => s.page.hasLoaded
);

export const selectUnreadCount = createSelector(selectNotificationsState, (s) => s.unreadCount);
